import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators'
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { TCCPHttpService } from '../../services/tccp-http.service';
import { TCCPConstantValues } from '../../models/tccp-constants';
import { TCCPLoggerService } from '../../services/tccp-logger.service';
import { environment } from '../../../../environments/environment';
import { Content } from '../../models/content';
import { LoaderService } from '../../loader/loader.service';

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {

  constructor(
    private httpService: TCCPHttpService, private http: HttpClient, private logger: TCCPLoggerService,
    private loaderService: LoaderService) { }

  public appBase = TCCPConstantValues[environment.applicationName];

  /** For service call to get regions
   * @class FeedbackService
   * @method sendFeedbackMail
    * @returns Observable
    * @param Feedback Object
   */

  sendFeedbackMail(feedback: Content): Observable<any> {
    const url = this.appBase.Urls.SEND_MAIL_URL;
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
      'Started getting flow', '');
    return this.httpService.post(url, feedback).pipe(
      map((data: any) => {
          this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting flow successful', JSON.stringify(data));
          return data;
        }),
        catchError((error: any) => {
          this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting flow failed', '', error);
          return error;
        })
    );
  }

  /** For service call to upload images to S3
     * @class FeedbackService
     * @method uploadImage
     * @param Disclaimer - flow name
     * @returns Observable
     */
  uploadImage(imageRequestBody) {
    const url = this.appBase.Urls.DIVISION_IMAGE_UPLOAD;
    return this.httpService.post(url, imageRequestBody).pipe(
      map((response: any) => {
        return response;
      })
      );
  }

  uploadtoS3(imageRequestBody, url, type) {
    this.loaderService.show();
    // Add Content-Type Header Info
    const header = new HttpHeaders();
    header.append('Content-Type', type);
    return this.http.put(url, imageRequestBody, { headers: header }).pipe(
      map((response: any) => {
        this.loaderService.hide();
        return response;
      })
      );
  }


}
